<template>
    <div class="container">
        <div class="handle-box-search">
            <el-row class="head-search">
                <el-col :span="8">
                    <span class="title" style="min-width: 100px">司机真实姓名:</span>

                    <el-input
                            v-model="search_data.driver_name"
                            placeholder="请输入司机姓名"
                            class="handle-input mr10"
                            @keyup.enter.native="searchdriverOrderConnectRecordLists"
                    ></el-input>
                </el-col>

                <el-col :span="8">
                    <span class="title" style="min-width: 100px">司机电话:</span>
                   
                    <el-input
                            v-model="search_data.driver_phone"
                            placeholder="请输入司机电话"
                            class="handle-input mr10"
                            maxlength="11"
                            @keyup.enter.native="searchdriverOrderConnectRecordLists"
                    ></el-input>
                </el-col>
            </el-row>


            <el-row class="head-search">
                <el-col :span="8">
                    <span class="title">起止时间:</span>
                    <el-date-picker v-model="search_time" type="daterange" range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                    @change="timeChange"
                                    style="width: 300px;">
                    </el-date-picker>
                </el-col>
            </el-row>



            <el-button type="primary" icon="el-icon-search" @click="searchdriverOrderConnectRecordLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>
        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="driver.name" label="司机姓名" min-width="150"> </el-table-column>
            <el-table-column prop="driver_verify.real_name" label="司机真实姓名" min-width="150"> </el-table-column>
            <el-table-column prop="driver.phone" label="司机电话" min-width="150"> </el-table-column>


            <el-table-column label="模式">
                <template slot-scope="scope">

                        {{ scope.row.mode == 'add' ? '收入' : '支出' }}

                </template>
            </el-table-column>


            <el-table-column prop="amount" label="金额" min-width="80"> </el-table-column>

            <el-table-column prop="description" label="说明" min-width="200"> </el-table-column>



            <el-table-column prop="date" label="时间" min-width="150"> </el-table-column>


        </el-table>
        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>
    </div>
</template>

<script>
    var _this
    export default {
        data() {
            return {
                // 存放表格数据
                tableData: [],

                search_time: '',

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    driver_name: '',
                    driver_phone: '',
                    fixed_time:''
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                }
            };
        },
        created() {
            _this = this;
            _this.driverOrderConnectRecordLists();

        },

        methods: {

            // 搜索时间选择触发
            timeChange(val) {

                if (val !== null) {
                    _this.search_data.fixed_time = JSON.stringify(['between'].concat(val));

                } else {
                    _this.search_data.fixed_time = '';
                }

                console.log(_this.search_data);

            },
            searchdriverOrderConnectRecordLists() {
                _this.search_data.page = 1;
                _this.driverOrderConnectRecordLists();
            },
            // 搜索用户管理列表
            driverOrderConnectRecordLists() {
                _this
                    .$post('/driver/driverOrderConnectRecordLists', _this.search_data, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;
                    })
                    .catch((err) => {});
            },
            // 翻页组件的回调
            pages_function(search_data) {
                console.log(_this.search_data);

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.driverOrderConnectRecordLists();
            },

            // 刷新按钮
            refresh() {
                this.$router.go(0);
            }
        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-dropdown {
        vertical-align: top;
    }

    .el-dropdown + .el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
</style>
